/**
 * @generated SignedSource<<ff246bd4eab27537a883082f41e1d8fb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarDetailsCustomization_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDescriptionAdditionalOptionsContent_user">;
  readonly " $fragmentType": "PdpRespSidebarDetailsCustomization_user";
};
export type PdpRespSidebarDetailsCustomization_user$key = {
  readonly " $data"?: PdpRespSidebarDetailsCustomization_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarDetailsCustomization_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarDetailsCustomization_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDescriptionAdditionalOptionsContent_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "334106c261f6215b2b9cd18926718b3a";

export default node;
